<template>
  <v-container>
    <v-row justify="end" class="mt-3">
      <v-col md="2">
        <v-btn color="success" small @click="createItem"
          >{{ $t("createNew") }} <v-icon>mdi-plus</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col md="10">
        <h3 class="mb-2">{{ $t("initiate.tabs.hourlyLeaves") }}</h3>
        <v-data-table :dark="$store.state.isDarkMode"
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-default-footer
          style="border: 1px solid #999; cursor: pointer"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.type }}</td>
              <td style="width: 80px">
                <v-icon color="grey" @click="navigate(item)">mdi-pencil</v-icon>
              </td>
              <td style="width: 80px">
                <v-icon color="red" @click="deleteitem(item)"
                  >mdi-delete</v-icon
                >
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog width="500" v-model="delete_dialog">
        <v-card>
          <v-card-title class="d-flex justify-center">
            <h2>
              {{ $t("are you sure delete") }}
            </h2>
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn
              color="green"
              @click="confirm_delete = true"
              class="white--text"
              depressed
              >{{ $t("submit") }}</v-btn
            >
            <v-btn
              color="red"
              class="white--text"
              depressed
              @click="delete_dialog = false"
              >{{ $t("cancel") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import i18n from '@/i18n';

export default {
  async created() {
    await axios.get("/hr/leave/type").then((res) => {
      this.items = res.data.leave_types;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].type == "hourly") {
          this.items[i].type = "ساعية";
        } else {
          this.items[i].type = "يومية";
        }
      }
      this.loading = false;
    });
  },
  watch: {
    confirm_delete() {
      if (this.confirm_delete == true) {
        axios.delete(`/hr/leave/type/${this.deleteItemId}`).then((res) => {
          this.items = this.items.filter(
            (item) => item.id !== this.deleteItemId
          );
          if (res.status == 200) {
            this.$Notifications(
              "تم حذف عهدة بنجاح",
              { rtl: true, timeout: 2500 },
              "success"
            );
          }
          this.delete_dialog = false;
          this.confirm_delete = false;
        });
      }
    },
  },
  data() {
    return {
      headers: [
        { text: i18n.t('name'), value: "name" },
        { text: i18n.t('hr.vacation.type'), value: "type" },
      ],
      items: [],
      loading: true,
      confirm_delete: false,
      delete_dialog: false,
      deleteItemId: null,
    };
  },
  methods: {
    
    navigate(name) {
      this.$router.push(`/vacations/${name.id}`);
    },
    createItem() {
      this.$router.push("/vacations/CreateNewVacation");
    },
    deleteitem(item) {
      this.deleteItemId = item.id;
      this.delete_dialog = true;
    },
  },
};
</script>